module.exports = __webpack_public_path__ + "assets/img/404.0ad7567c.png";